import contactForm from '@/api/contact_forms'

export default ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    contactForm.setContactFormButton(result => {
      resolve(result.data.data)
    }, param)
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/contact_forms/actions/setContactFormButton.js